import React from 'react';
import { bootMark } from './lib/bootProfile';
import ReactDOM from 'react-dom/client';
import App from './App';

bootMark('js');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
